import { useState } from "react";
import { t } from "@/i18n-js/instance";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Typography } from "@circle-react-uikit/Typography";

interface ContentHideableProps {
  className?: string;
  description: string;
  maximumLength: number;
  shouldShowMoreInitialState?: boolean;
}

export const ContentHideable = ({
  description,
  className,
  shouldShowMoreInitialState = false,
  maximumLength = 160,
}: ContentHideableProps) => {
  const [shouldShowMoreText, setShouldShowMore] = useState(
    shouldShowMoreInitialState,
  );
  const onClick = () => {
    setShouldShowMore(!shouldShowMoreText);
  };

  return (
    <div className={classNames(className)}>
      <Typography.BodySm color="text-default">
        {shouldShowMoreText ? (
          <span className="flex flex-col gap-y-1 whitespace-pre-wrap">
            {description}
            <button
              type="button"
              className="text-left underline"
              onClick={onClick}
            >
              {t("show_less")}
            </button>
          </span>
        ) : (
          <span className="whitespace-pre-wrap">
            {`${description.substring(0, maximumLength)}... `}
            <button type="button" className="underline" onClick={onClick}>
              {t("show_more")}
            </button>
          </span>
        )}
      </Typography.BodySm>
    </div>
  );
};
